const TEST = false;
// to test different screens
// const TEST = false; // to test flow of process
// eslint-disable-next-line no-unused-vars
const createAccountHref =
  "https://99bkuw2bnl7gjqna-8061485119.shopifypreview.com/account/activate/5654378643519/37d14c2dec71bb58105b063a51fbdf7c-1652881020?utm_source=shopify&utm_medium=activation%20email&utm_campaign=new%20customers&m=a2FyYV9tYWdlQHlhaG9vLmNvbQ";

const REQUEST_ACTIVATION = "REQUEST ACTIVATION";

/**
 * Activate
 * @param filename the bootstrap filename returned using liquid's asset_url.
 */
// eslint-disable-next-line no-unused-vars
function handleSubmit(event) {
  event.keyCode === 13 ? requestActivation() : null;
}

/**
 * Hides each of the selectors contained in the array.
 * @param selectors array of strings representing classes/IDs of HTML elements.
 */
const hideSelectors = function (selectors) {
  selectors.forEach((selector) => {
    $(selector).addClass("hide");
  });
};

/**
 * Shows each of the selectors contained in the array.
 * @param selectors array of strings representing classes/IDs of HTML elements.
 */
const showSelectors = function (selectors) {
  selectors.forEach((selector) => {
    $(selector).removeClass("hide");
  });
};

function showHideMobileHR() {
  if ($(window).width() > 768) {
    $(".mobile-divide__wrapper").hide();
  } else {
    $(".mobile-divide__wrapper").show();
  }
}
/**
 * Shows the appropriate elements for the activation information modal.
 */
const showActivateInfoModal = function () {
  showSelectors([".activate-info", ".btn-modal-cancel"]);
  hideSelectors([
    ".main-login",
    ".activation",
    ".recover-password",
    ".success_password_recovery",
    ".testimonial-wrapper",
    ".login-content-aux",
    ".main-login-logo",
    ".form-group-customer-support--main",
    ".mobile-divide__wrapper",
    ".form-group-customer-support",
  ]);

  $(".login-container").removeClass("default-login");
  $(".card").addClass("card--taller-padding-top");
  $(".activate-info .btn-modal-cancel").focus;

  // calls the HTML5 history API to adjust the url after 1 millisecond
  setTimeout(() => {
    history.replaceState(
      "",
      document.title,
      window.location.origin + window.location.pathname + window.location.search
    );
  }, 1);
};

/**
 * Shows the appropriate elements for the activation modal.
 */
const showActivationModal = function () {
  showSelectors([
    ".activation",
    ".request-activation-form",
    ".testimonial-wrapper",
  ]);
  hideSelectors([
    ".recover-password",
    ".success_password_recovery",
    ".close-modal",
    ".confirm_identity",
    ".email_not_recognized",
    ".account_already_exists",
    ".whoops",
    ".form-group-exit-here-screens",
    ".main-login",
    ".activate-info",
    ".main-login-logo",
    ".login-content-aux",
    ".testimonial-wrapper",
    ".mobile-divide__wrapper",
    ".form-group-customer-support--main",
  ]);

  $(".form-group-customer-support").css("flex-direction", "column");
  $(".login-container").removeClass("default-login");
  $(".testimonial").addClass("request-activation--top-margin");
  $(".login-wrapper").removeClass("not-recognized--padding");
  $(".card").removeClass("card--taller-padding-top");

  // calls the HTML5 history API to adjust the url after 1 millisecond
  setTimeout(() => {
    history.replaceState(
      "",
      document.title,
      window.location.origin + window.location.pathname + window.location.search
    );
  }, 1);
};

/**
 * Shows the appropriate elements for the main login screen.
 */
const showLoginModal = function () {
  showSelectors([
    ".main-login",
    ".login-content-aux",
    ".main-login-logo",
    ".testimonial-wrapper",
  ]);
  hideSelectors([
    ".btn-cancel",
    ".recover-password",
    ".success_password_recovery",
    ".activate-info",
    ".activation",
  ]);
};

const onButtonCancel = function () {
  showSelectors([
    ".checkout-url",
    ".main-login",
    ".login-content-aux",
    ".testimonial-wrapper",
    ".main-login-logo",
    ".mobile-divide__wrapper",
    ".form-group-customer-support--main",
  ]);
  hideSelectors([
    ".btn-cancel",
    ".close-modal",
    ".recover-password",
    ".success_password_recovery",
    ".activate-info",
    ".activation",
  ]);

  showHideMobileHR();
  $(".form-group-exit-here-screens").removeClass("activation-info-exit");
  $(".login-container").addClass("default-login");
};

const showResetPassword = function () {
  showSelectors([
    ".btn-modal-cancel",
    ".btn-cancel",
    ".recover-password",
    ".logging-in-help",
    ".form-group-customer-support",
  ]);
  hideSelectors([
    ".checkout-url",
    ".confirm_identity",
    ".email_not_recognized",
    ".account_already_exists",
    ".success_password_recovery",
    ".whoops",
    ".main-login",
    ".activate-info",
    ".activation",
    ".main-login-logo",
    ".login-content-aux",
    ".testimonial-wrapper",
    ".mobile-divide__wrapper",
    ".form-group-customer-support--main",
  ]);

  $(".login-container").removeClass("default-login");
  $(".testimonial").addClass("recover-password--top-margin");
  $(".card").addClass("card--taller-padding-top");
  $(".recover-password .btn-modal-cancel").focus;
};

const showSuccessPasswordReset = function () {
  showSelectors([
    ".btn-modal-cancel",
    ".btn-cancel",
    ".success_password_recovery",
  ]);
  hideSelectors([
    ".checkout-url",
    ".confirm_identity",
    ".email_not_recognized",
    ".recover-password",
    ".account_already_exists",
    ".whoops",
    ".main-login",
    ".activate-info",
    ".activation",
    ".login-content-aux",
    ".main-login-logo",
    ".testimonial-wrapper",
    ".mobile-divide__wrapper",
    ".form-group-customer-support--main",
  ]);

  $(".login-container").removeClass("default-login");
};

/**
 * Shows the appropriate elements for the identity confirmation modal.
 */
const showConfirmIdentity = function () {
  showSelectors([".confirm_identity", ".btn-close-screen"]);
  hideSelectors([
    ".request-activation-form",
    ".email_not_recognized",
    ".account_already_exists",
    ".whoops",
    ".testimonial-wrapper",
    ".mobile-divide__wrapper",
  ]);

  $(".card").addClass("card--taller-padding-top");
  $(".activation .btn-close-screen").focus;
};

const showEmailNotRecnogized = function () {
  showSelectors([
    ".email_not_recognized",
    ".btn-close-screen",
    ".form-group-exit-here-screens",
  ]);
  hideSelectors([
    ".request-activation-form",
    ".confirm_identity",
    ".account_already_exists",
    ".whoops",
    ".testimonial-wrapper",
    ".mobile-divide__wrapper",
  ]);

  $(".login-wrapper").addClass("not-recognized--padding");
  $(".card").addClass("card--taller-padding-top");
  $(".activation .btn-close-screen").focus;
};

const showAccountExists = function () {
  showSelectors([
    ".account_already_exists",
    ".btn-close-screen",
    ".form-group-exit-here-screens",
  ]);
  hideSelectors([
    ".request-activation-form",
    ".confirm_identity",
    ".email_not_recognized",
    ".whoops",
    ".testimonial-wrapper",
    ".mobile-divide__wrapper",
  ]);

  $(".card").addClass("card--taller-padding-top");
  $(".activation .btn-close-screen").focus;
};

const showWhoops = function () {
  showSelectors([
    ".whoops",
    ".btn-close-screen",
    ".form-group-exit-here-screens",
  ]);
  hideSelectors([
    ".request-activation-form",
    ".confirm_identity",
    ".account_already_exists",
    ".email_not_recognized",
    ".testimonial-wrapper",
    ".mobile-divide__wrapper",
  ]);

  $(".card").addClass("card--taller-padding-top");
  $(".activation .btn-close-screen").focus;
};

const requestActivation = async function () {
  if (TEST) {
    setTimeout(showEmailNotRecnogized, 1000);
  } else {
    const email = $("#activation-email").val().replace(/\s/g, "");

    if (!validateEmail(email)) {
      $("#activation-email").css("border", "2px solid red");
      $("#activation-email-error").text("Please enter a valid email");
    } else {
      $("#request-activation-button").html(
        '<img class="spinner" src="//cdn.shopify.com/s/files/1/0080/6148/5119/files/tail-spin.svg" width="20">'
      );

      const userExistsInput = { email: email };

      const userExistsRes = await XAPIClient.userExists(userExistsInput);
      const status = userExistsRes.data.userExists.status;
      const exists = userExistsRes.data.userExists.exists;
      const numberOfOrders = userExistsRes.data.userExists.numberOfOrders;

      if (!exists) {
        showEmailNotRecnogized();
        $(".btn-request-activation").html(REQUEST_ACTIVATION);
        return;
      }

      /**  the user already has an account and can log in */
      if (status === "ENABLED") {
        showAccountExists();
        $(".btn-request-activation").html(REQUEST_ACTIVATION);
        return;
      } else {
        if (numberOfOrders > 0) {
          // TODO: XAPI Client needs to check source string as toLowerCase()
          const inviteInput = {
            email: email,
            source: "GOLO",
          };
          XAPIClient.inviteUser(inviteInput)
            // eslint-disable-next-line no-unused-vars
            .then(() => {
              showConfirmIdentity();
            })
            // eslint-disable-next-line no-unused-vars
            .catch((_, __, exception) => {
              console.error(exception);
              showWhoops();
            });
        } else {
          showEmailNotRecnogized();
        }
      }

      $(".btn-request-activation").html(REQUEST_ACTIVATION);
    }
  }
};

/**
 * Shows a custom error message on the login form.
 *
 * @param {Array<string>} errors Errors to display.
 */
const showErrors = (...errors) => {
  const errorsDiv = document.getElementById("customer_login");
  const errorElement =     `
  <div class="errors">
    <ul>${errors.map((error) => `<li>${error}</li>`).join("")}</ul>
  </div>
  `
  errorsDiv.insertBefore(errorElement, errorsDiv.firstChild);
};

const handleButtonLoading = (loading = false) => {
  const loadingIndicator = $(".loadingIndicator");
  const submitButton = $("#btn-login");

  submitButton
    .attr("disabled", loading)
    .css("cursor", loading ? "default" : "");
  submitButton.find("span").toggleClass("d-none", loading);
  loadingIndicator.toggleClass("d-none", !loading);
};

/**
 * Authenticates a user through the myGOLO XAPI. This sets an authentication
 * token cookie, allowing the user to access the XAPI using it.
 *
 * @param {Event} event The button clicking event.
 */
const handleLogin = async (event) => {
  event.preventDefault();
  handleButtonLoading(true);
  const email = $("#email").val().replace(/\s/g, "");
  const password = $("#password").val().replace(/\s/g, "");
  const XAPI_COOKIE = "golo-xapi-response";
  let timeout = null;
  if (!email || !password) $("#customer_login").emit("submit");
  else {
    // Displays an error message if it takes longer than normal to log a user in
    timeout = setTimeout(
      () =>
        golo.toast(
          "This is taking longer than expected. Please wait, you will be logged in shortly.",
          {
            title: "Sorry!",
            state: "error",
            icon: "fa-regular fa-stopwatch",
            iconColor: "#006faf",
          }
        ),
      5000
    );
    const { authentication, isCustomizer } = GOLO_SHOPIFY_DATA;
    // if using Auth0 and are in the customizer, we cannot redirect outside
    // GOLO so we need to use the Auth0 SAPI to get a token and login manually
    if (authentication.type === "auth0" && isCustomizer) {
      handleButtonLoading(true);
      fetch("https://auth0-sapi.golo.dev/auth/rofg", {
        method: "POST",
        headers: {
          "x-api-key": "C3B8BseZuUlEnpa1VPTj1whJHQjfFmC3"
        },
        body: JSON.stringify({
          username: email,
          password,
          audience: "https://mygolo-xapi.golo.com",
          clientId: authentication.clientId
        })
      })
        .then((res) => res.json())
        .then((data) => {
          console.error(data);
          if (data.ok) {
            const { access_token, id_token } = data.data;
            const base64Url = id_token.split(".")[1];
            const base64 = base64Url
              .replace(/-/g, "+")
              .replace(/_/g, "/")
              .padEnd(Math.ceil(base64Url.length / 4) * 4, "=");
            const decodedData = JSON.parse(atob(base64));
            localStorage.setItem("___azt", access_token);
            fetch(decodedData.multipass_url).then(() => {
              window.location.href = "/pages/resources-myg1"
            })
          } else {
            throw new Error("Invalid username or password");
          }
        })
        .catch((err) => {
          console.error("Failed to login via customizer", err);
          golo.toast("Failed to login to customizer: " + err, {
            title: "Oops!", timeout: 15000
          })
        }).finally(handleButtonLoading)
    } else {
      try {
        XAPIClient.login(email, password)
          .then(async (json) => {
            try {
              const { data = null, errors = null } = json || {};
  
              // if there are errors, display the error on the login form
              if (data === null && errors) {
                const message = errors[0].message;
                showErrors(
                  message === "The user is not permitted to access this resource"
                    ? "Invalid email or password"
                    : message + ". Please try again"
                );
                console.error(
                  `Customer failed to authenticate through the XAPI: ${message}`,
                  errors
                );
  
                // set the cookie to show the xapi token failed to be set
                golo.setCookie(XAPI_COOKIE, {
                  status: false,
                  message: message,
                });
              } else {
                handleButtonLoading(false);
  
                // set the cookie to show the xapi token was successfully set
                golo.setCookie(
                  XAPI_COOKIE,
                  { status: true },
                  { expiration: data.login.expires }
                );
              }
            } catch (error) {
              console.error(error);
            } finally {
              $("#customer_login").submit();
            }
          })
          .catch((error) => {
            // print the error for debugging here
            console.error(error);
  
            // set the cookie to show the xapi token failed to be set
            golo.setCookie(XAPI_COOKIE, { status: false, message: error });
  
            // submit the form to Shopify regardless of the response from XAPI
            $("#customer_login").submit();
          })
          .finally(() => {
            if (timeout) {
              clearTimeout(timeout);
            }
          });
      } catch (e) {
        // print the error for debugging here
        console.error(e);
        // set the cookie to show the xapi token failed to be set
        golo.setCookie(XAPI_COOKIE, { status: false, message: e });
        $("#customer_login").submit();
      }
    }

    
  }
};

const togglePassword = (event) => {
  event.preventDefault();
  const passwordIcon = $(".password-icon");
  const password = $("#password");
  const passwordType =
    password.attr("type") === "password" ? "text" : "password";
  password.attr("type", passwordType);
  passwordIcon.toggleClass("hide-password");
};

/**
 * Checks the URL for anchor tags representing the different screens.
 * If the anchor tag is not recognized, the login screen is shown.
 */
$(() => {
  // password reset success
  if (window.location.href.indexOf("#recover-success") > -1) {
    showSuccessPasswordReset();
    // password reset
  } else if (window.location.href.indexOf("#recover") > -1) {
    showResetPassword();
    // activation information
  } else if (window.location.href.indexOf("#activation-info") > -1) {
    showActivateInfoModal();
    // activate
  } else if (window.location.href.indexOf("#activate") > -1) {
    showActivationModal();
    // default is login
  } else {
    $("#email").emit("blur");
    showLoginModal();
  }

  $("#request-activation-button").on("click", requestActivation);
  $(".btn-reset-password").on("click", showResetPassword);
  $(".btn-cancel").on("click", onButtonCancel);
  $(".btn-cancel-screen").on("click", showActivationModal);
  $(".btn-modal-cancel").on("click", onButtonCancel);
  $(".btn-close-screen").on("click", showActivationModal);
  $(".btn-email-not-recognized").on("click", showActivationModal);
  $(".btn-activate-info").on("click", showActivateInfoModal);
  $(".btn-cancel-exit").on("click", onButtonCancel);
  $(".btn-close-success-screen").on("click", showResetPassword);
  $("#btn-login").on("click", handleLogin);
  $(".password-icon").on("click", togglePassword);
});
